<template>


  <h1>AI Email Template</h1>


</template>
<script>

export default {
  props: {
    vehicleInfo: {
      type: Object,
      required: false
    },
    msrpDetails: {
      type: Array,
      required: false
    }
  },
  data() {
    return {

    }
  },
  computed: {
    vehicleDisplayName() {
      if (!this.vehicleInfo) {
        return "";
      }
      const { year, make, model, trim } = this.vehicleInfo;
      return [year, make, model, trim].filter(Boolean).join(" ");
    },

  },
  methods: {
    getVehicleIntExteriorColorStyle(colorHexCode, colorGeneric) {
      if (colorHexCode === "" && colorGeneric === "") {
        return {
          "background-color": "transparent",
          border: "1px solid #ccc",
        };
      }

      const color = colorHexCode ? `#${colorHexCode}` : colorGeneric;
      return { "background-color": `${color} !important`, "border-color": `${color} !important` };
    },
  }
}
</script>
<style lang="">

</style>
